import { BookmarkIcon } from '@heroicons/react/24/outline'
import ChoicePrompt from './ChoicePrompt'
import { useChat } from '../../providers/chat/context'

export default function SummarizationPrompt() {
  const { pendingSummarization, busy, summarize } = useChat()
  if (!pendingSummarization) return null

  const disabled = busy === 'summarizing'

  return (
    <ChoicePrompt
      icon={<BookmarkIcon className="size-3.5 text-purple-700" />}
      title="Chat memory is nearly full"
      description="Pick how much history to summarize. Older messages stay in scroll-back."
      actions={[
        {
          label: 'Summarize ~100%',
          variant: 'outline',
          disabled: disabled || !pendingSummarization.includes('100'),
          onClick: () => void summarize('100'),
        },
        {
          label: 'Summarize ~70%',
          variant: 'primary',
          disabled: disabled || !pendingSummarization.includes('70'),
          onClick: () => void summarize('70'),
        },
      ]}
    />
  )
}
